import { render } from "./PagePaint.vue?vue&type=template&id=35f5095c&scoped=true"
import script from "./PagePaint.vue?vue&type=script&lang=js"
export * from "./PagePaint.vue?vue&type=script&lang=js"

import "./PagePaint.vue?vue&type=style&index=0&id=35f5095c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f5095c"]])

export default __exports__